module.exports = __webpack_public_path__ + "static/media/messages.44eb809f.svg";